import Loader from '@components/Loader/Loader';
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { ZIndexOptions } from '@mui/material/styles/zIndex';
import { SIDE_BAR_WIDTH, TOP_PANE_BAR_HEIGHT } from 'constants/Theme/BaseTheme';
import React from 'react';
import { ITheme } from 'types/theme';

const LoginLoader: React.FC = () => {
	const theme = useTheme<ITheme>();

	return (
		<Box
			display="flex"
			flexGrow={1}
			justifyContent="center"
			alignItems="center"
			sx={{
				backgroundColor: theme.palette.background.default
			}}
			data-testid="login-loader"
		>
			<Box
				position="fixed"
				top={0}
				height={TOP_PANE_BAR_HEIGHT}
				width="100%"
				sx={{
					backgroundColor: theme.palette.mode === 'dark' ? grey[900] : grey[50]
				}}
			>
				<Skeleton variant="rectangular" height="100%" />
			</Box>
			<Box
				width={SIDE_BAR_WIDTH}
				position="fixed"
				top={TOP_PANE_BAR_HEIGHT}
				bottom={0}
				left={0}
				sx={{
					backgroundColor: theme.palette.mode === 'dark' ? grey[900] : grey[50]
				}}
			>
				<Skeleton variant="rectangular" height="100%" />
			</Box>
			<Box
				width={500}
				textAlign="center"
				zIndex={(theme.zIndex as ZIndexOptions).tooltip}
			>
				<Box>
					<Typography variant="h5" color="text.primary">
						{intl.tr('login.loader.message')}
					</Typography>
				</Box>
				<Box textAlign="center" mt={4}>
					<Loader isLoading variant="circular" />
				</Box>
			</Box>
		</Box>
	);
};

export default LoginLoader;
